import React, { FC, FunctionComponent, Suspense, useEffect } from 'react';
import { Route, Routes } from 'react-router-dom';

import Loader from 'src/components/widgets/loader';
import NotFoundPage from '../components/pages/_notFound';
import administratorRoutes from '../shared/administratorRoutes';
import { Center } from '../shared/globals';
import { backofficeUrl, routeMatchUrl } from '../shared/helpers';
import { AdmininistratorLayoutContainer } from './administratorLayoutContainer';

const AdministratorLayout: FunctionComponent<{ children?: React.ReactNode }> = () => {
    // Add a class login page to body only on mount and remove it on unmount
    useEffect(() => {
        document.body.classList.add('admin-page');
        return () => {
            document.body.classList.remove('admin-page');
        };
    }, []);

    return (
        <Suspense
            fallback={
                <Center>
                    <Loader />
                </Center>
            }
        >
            <AdmininistratorLayoutContainer>
                <Routes>
                    {administratorRoutes.map((route, index) => {
                        return <Route key={index} path={routeMatchUrl(backofficeUrl(route.url))} element={React.createElement(route.component as FC<{}>)} />;
                    })}
                    <Route path='*' element={<NotFoundPage />} />
                </Routes>
            </AdmininistratorLayoutContainer>
        </Suspense>
    );
};

export default AdministratorLayout;
